type ObjectUrlCreator = {
	createObjectURL: (blob: Blob) => string;
};

export function useCreateObjectUrl(): ObjectUrlCreator {
	const createObjectURL = (blob: Blob) => {
		return window.URL.createObjectURL(blob);
	};

	return { createObjectURL };
}
